angular.module('controllers').controller('interiorController', ['$scope', '$rootScope', '$controller', '$route', '$routeParams', '$location', 'Crud',
	function ($scope, $rootScope, $controller, $route, $routeParams, $location, Crud) {
		$rootScope.path = '/interior';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'interior';
		$scope.pathTemplate = 'calls/interiors';
		$scope.title = 'Interioare';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'interior_name';
		$scope.defaultItem = 10;
        $rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'interior_name':{'label':'Nume', 'filter':1, 'filterType':'input'},
            'interior_no':{'label':'Numar', 'filter':1, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.additionals = [];
		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'interior_no';

		
	}]
);
